/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { Box, useMediaQuery } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrganizationStructureOld from "../../../../components/common/OrganizationStructure/OrganizationStructureOld";
import OrganizationStructure from "../../../../components/common/OrganizationStructure/OrganizationStructure"; // ✅ NEW
import { OS_DROPDOWN_KEYS } from "../../../../contants";
import useQueryParams from "../../../../hooks/useQueryParams";
import { selectUserProfile } from "../../../../redux/selectors/user";
import { isEmptyObj } from "../../../../utils/helper";

function OrganizationSearch({
  values,
  handleChange,
  errors,
  setFieldValue,
  disabledOSKeys,
  selectedDate, // ✅ NEW
}) {
  const [shouldFetchOtherOS, setShouldFetchOtherOS] = useState(false);
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const userData = useSelector(selectUserProfile);

  const isMobile = useMediaQuery("(max-width: 768px)");

  // 🔥 DATE BASED SWITCH (FIXED)

  const parsedDate = selectedDate
    ? new Date(selectedDate?.$d || selectedDate)
    : null;

  const isClusterFlow =
    parsedDate &&
    parsedDate.getTime() >= new Date("2026-04-01T00:00:00").getTime();

  const OSComponent = isClusterFlow
    ? OrganizationStructure
    : OrganizationStructureOld;

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      disabledOSKeys.forEach((key) => {
        if (userData[key]) {
          setFieldValue(key, userData[key]);
        }
      });
      setShouldFetchOtherOS(true);
    }
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      OS_DROPDOWN_KEYS.forEach((key) => {
        setFieldValue(key, Number(query[key]));
      });
      setShouldFetchOtherOS(true);
    } else {
      OS_DROPDOWN_KEYS.forEach((key) => {
        if (!disabledOSKeys?.includes(key)) {
          setFieldValue(key, "");
        }
      });
      preselectOSKeys();
    }
  }, [urlSearchParams.toString(), disabledOSKeys, userData]);

  return (
    <OSComponent
      values={values}
      handleChange={handleChange}
      errors={errors}
      setFieldValue={setFieldValue}
      showZoneLocator={false}
      showTitle={false}
      containerStyle={{
        border: "none",
        padding: "0px 10px 0px 0px",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(7, 1fr)",
        columnGap: isMobile ? "0px" : "12px",
        rowGap: isMobile ? "0px" : "0px",
        alignItems: "flex-start",
      }}
      required={false}
      useHiddenInput
      storeValuesInRedux
      showBlock
      shouldFetchOtherOS={shouldFetchOtherOS}
      disabledOSKeys={disabledOSKeys}
    />
  );
}

function OrganizationSearchWrapper({ disabledOSKeys, selectedDate }) {
  return (
    <Box
      sx={{
        "& .MuiFormLabel-root": {
          fontSize: "12px !important",
          fontWeight: "600 !important",
        },
        "& .MuiOutlinedInput-root": {
          minWidth: "140px",
        },
        "& .MuiOutlinedInput-input": {
          height: "14px",
          paddingRight: "32px !important",
        },
        "& .MuiInputBase-input": {
          fontSize: "12px !important",
          fontWeight: 600,
        },
        "& .MuiSelect-select": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          paddingRight: "32px !important",
          display: "block",
          width: "100%",
        },
        "& .MuiSelect-icon": {
          right: "4px",
        },
      }}
    >
      <Formik initialValues={{}}>
        {({ values, errors, handleChange, setFieldValue }) => (
          <OrganizationSearch
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            disabledOSKeys={disabledOSKeys}
            selectedDate={selectedDate} // ✅ PASS DATE
          />
        )}
      </Formik>
    </Box>
  );
}

export default OrganizationSearchWrapper;
